import { type InitialStateLoaderPayoutSetup_Query$data } from '#app/__generated__/relay/InitialStateLoaderPayoutSetup_Query.graphql.js';
import { type InitialState } from './reducer/state.js';

export const getStateFromUserAccount = (
  userAccount: InitialStateLoaderPayoutSetup_Query$data['visitor']['userAccount'],
): InitialState | null => {
  if (!userAccount) {
    return null;
  }

  const bankStripeHostedPrerequisite =
    userAccount.payoutAccountEligibility.stripeBankAccountPayouts.flow
      ?.__typename ===
    'StripeBankAccountPayoutAccountEligibilityFlowStripeHosted'
      ? userAccount.payoutAccountEligibility.stripeBankAccountPayouts.flow
          .prerequisiteStripeHosted
      : null;

  const bankContraInAppPrerequisite =
    userAccount.payoutAccountEligibility.stripeBankAccountPayouts.flow
      ?.__typename ===
    'StripeBankAccountPayoutAccountEligibilityFlowContraInApp'
      ? userAccount.payoutAccountEligibility.stripeBankAccountPayouts.flow
          .prerequisiteInApp
      : null;

  // ignore the states that won't exist (to satisfy typescript)
  if (
    userAccount.payoutAccountEligibility.stripeDebitCardPayouts
      .eligibilityStatus === '%future added value' ||
    userAccount.payoutAccountEligibility.stripeDebitCardPayouts.prerequisite ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.usdcPayouts.eligibilityStatus ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.usdcPayouts.prerequisite ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.airwallexPayouts.eligibilityStatus ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.airwallexPayouts
      .airwallexBankAccountSupport === '%future added value' ||
    userAccount.payoutAccountEligibility.airwallexPayouts.prerequisite ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.paypalPayouts.eligibilityStatus ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.payoneerPayouts.eligibilityStatus ===
      '%future added value' ||
    userAccount.payoutAccountEligibility.stripeBankAccountPayouts
      .eligibilityStatus === '%future added value' ||
    bankStripeHostedPrerequisite === '%future added value' ||
    bankContraInAppPrerequisite === '%future added value'
  ) {
    return null;
  }

  const stripeDebitCardPayouts: InitialState['payoutAccountEligibility']['stripeDebitCardPayouts'] =
    {
      eligibilityStatus:
        userAccount.payoutAccountEligibility.stripeDebitCardPayouts
          .eligibilityStatus,
      prerequisite:
        userAccount.payoutAccountEligibility.stripeDebitCardPayouts
          .prerequisite,
    };
  const paypalPayouts: InitialState['payoutAccountEligibility']['paypalPayouts'] =
    {
      eligibilityStatus:
        userAccount.payoutAccountEligibility.paypalPayouts.eligibilityStatus,
    };

  const payoneerPayouts: InitialState['payoutAccountEligibility']['payoneerPayouts'] =
    {
      eligibilityStatus:
        userAccount.payoutAccountEligibility.payoneerPayouts.eligibilityStatus,
    };

  const usdcPayouts: InitialState['payoutAccountEligibility']['usdcPayouts'] = {
    eligibilityStatus:
      userAccount.payoutAccountEligibility.usdcPayouts.eligibilityStatus,
    prerequisite: userAccount.payoutAccountEligibility.usdcPayouts.prerequisite,
  };

  const airwallexPayouts: InitialState['payoutAccountEligibility']['airwallexPayouts'] =
    {
      airwallexBankAccountSupport:
        userAccount.payoutAccountEligibility.airwallexPayouts
          .airwallexBankAccountSupport,
      eligibilityStatus:
        userAccount.payoutAccountEligibility.airwallexPayouts.eligibilityStatus,
      prerequisite:
        userAccount.payoutAccountEligibility.airwallexPayouts.prerequisite,
    };

  const bankFlow =
    userAccount.payoutAccountEligibility.stripeBankAccountPayouts.flow;

  const stripeBankAccountPayouts: InitialState['payoutAccountEligibility']['stripeBankAccountPayouts'] =
    {
      eligibilityStatus:
        userAccount.payoutAccountEligibility.stripeBankAccountPayouts
          .eligibilityStatus,
      flow:
        bankFlow?.__typename ===
        'StripeBankAccountPayoutAccountEligibilityFlowContraInApp'
          ? {
              __typename: bankFlow?.__typename,
              prerequisite: bankContraInAppPrerequisite ?? null,
            }
          : bankFlow?.__typename ===
              'StripeBankAccountPayoutAccountEligibilityFlowStripeHosted'
            ? {
                __typename: bankFlow?.__typename,
                prerequisite: bankStripeHostedPrerequisite ?? null,
              }
            : null,
    };

  const value: InitialState = {
    canEditCountry: userAccount.businessOperationsCountry.canEdit,
    initialCountryCode: userAccount.businessOperationsCountry.countryCode,
    payoutAccountEligibility: {
      airwallexPayouts,
      payoneerPayouts,
      paypalPayouts,
      stripeBankAccountPayouts,
      stripeDebitCardPayouts,
      usdcPayouts,
    },
    stripeRequiresOnboardingAction:
      userAccount.stripeAccount.requiresConnectOnboardingAction,
    verifiedIdentity: userAccount.verifiedIdentity
      ? {
          location: userAccount.verifiedIdentity?.location ?? null,
          locationMatchesUserAccountLocation:
            userAccount.verifiedIdentity?.locationMatchesUserAccountLocation ??
            false,
        }
      : null,
  };

  return value;
};
